import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    headerGrid: {
        paddingTop: '2rem', 
        paddingLeft: '1rem',
        textAlign: 'center'
    },
    mapGrid: {
        padding: '1rem'
    },
    paper: {
        maxWidth: '1005px',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(1),
        backgroundColor: '#606060'
    },
    mapContainer: {
        maxWidth: '1005px', 
        height: '500px', 
        overflow: 'hidden' 
    },
    mapIframe: {
        width: '100%', 
        overflow: 'hidden'
    }
})

class BroadcastMapComponent extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <Grid container direction="row">
                <Grid item xs={12} className={classes.headerGrid}>
                    <Typography variant="h4">
                        Map Broadcast
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} className={classes.mapGrid}>
                    <Paper className={classes.paper} variant="outlined">
                        <div className={classes.mapContainer}>
                            <iframe height="500px" className={classes.mapIframe}
                                scrolling="no" title="fx." src="http://hydrologywp.selfip.com/hydrologyKL/googlemapweek.php"
                                frameBorder="yes" allowtransparency="true" allowFullScreen={true}>

                            </iframe>
                        </div>

                    </Paper>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles, { withTheme: true })(BroadcastMapComponent);